import { get, omit } from 'lodash';
import { httpClient } from '../../../lib/utils';
import { envValue } from '../../../config/envUtils';
import { SAVE_LEVEL } from '../../constants/Level';
import { Service } from '../Service';
import store from '../../store/Store';
import * as ActionTypes from '../../constants/ActionTypes';
const SOURCEURL = envValue('SOURCEURL');
const auth = reactCookie.load('auth', false);
import moment from 'moment';

export const CATEGORIES = {
    IMAGE: 'Image',
    VIDEO: 'Video',
    FONT: 'Font',
    CUSTOMIZATION: 'Customization',
    TRACKING: 'Tracking',
    OTHER: 'Other'
};

export class FileService extends Service {
    static upload(chainId, hotelId, saveLevel = SAVE_LEVEL.HOTEL, file, progress, metaData = {}) {
        let uploadData = new FormData();
        uploadData.append('Authorization', `${httpClient.defaults.headers.common.Authorization}`);
        uploadData.append('file', file);
        for (let [k, v] of Object.entries(omit(Object.assign({}, metaData, file.metadata), ['category']))) {
            uploadData.append(k, v);
        }
        return httpClient
            .post(
                `${SOURCEURL}/shs-bedesigner-services/files?${FileService.fileParamProxy(
                    chainId,
                    hotelId,
                    null,
                    saveLevel,
                    file.rename || file.name,
                    metaData.category
                )}${file.override ? '&update=true' : ''}`,
                uploadData,
                progress
            )
            .catch(e => {
                return Promise.reject({
                    message: get(e, ['response', 'data', 'Result', 'Description'], e),
                    title: file.name,
                    file: file
                });
            });
    }

    static get(chainId, hotelId, saveLevel = SAVE_LEVEL.HOTEL, file, category) {
        return httpClient.get(
            `${SOURCEURL}/shs-bedesigner-services/files?${FileService.fileParamProxy(
                chainId,
                hotelId,
                null,
                saveLevel,
                file,
                category
            )}`
        );
    }
    static getByName(name) {
        const fragments = name.split('/').slice(1);
        let chainId, hotelId, brandId, category, filename;
        for (let i = 0; i < fragments.length; i++) {
            switch (fragments[i]) {
                case 'chain':
                    if (fragments.length > i + 1) {
                        chainId = fragments[i + 1];
                        i++;
                    }
                    break;
                case 'hotel':
                    if (fragments.length > i + 1) {
                        hotelId = fragments[i + 1];
                        i++;
                    }
                    break;
                case 'brand':
                    if (fragments.length > i + 1) {
                        brandId = fragments[i + 1];
                        i++;
                    }
                    break;
                case 'fileStorage':
                    if (fragments.length > i + 2) {
                        category = fragments[i + 1];
                        filename = fragments[i + 2];
                        i += 2;
                    }
                    break;
            }
        }
        return httpClient.get(
            `${SOURCEURL}/shs-bedesigner-services/files?${FileService.fileParamProxy(
                chainId,
                hotelId,
                null,
                hotelId ? SAVE_LEVEL.HOTEL : SAVE_LEVEL.CHAIN,
                filename,
                category.charAt(0).toUpperCase() + category.slice(1)
            )}`
        );
    }
    static getList(chainId, hotelId, saveLevel = SAVE_LEVEL.HOTEL, category) {
        return httpClient
            .get(
                `${SOURCEURL}/shs-bedesigner-services/files/all?${FileService.fileParamProxy(
                    chainId,
                    hotelId,
                    null,
                    saveLevel,
                    null,
                    category
                )}`
            )
            .then(response => {
                store.dispatch({ type: ActionTypes.SET_ASSETS_LIST, assetsList: response.data });
                return response.data;
            })
            .catch(error => {
                store.dispatch({ type: ActionTypes.SET_ASSETS_LIST, assetsList: [] });
                return Promise.reject(error);
            });
    }

    static delete(chainId, hotelId, saveLevel = SAVE_LEVEL.HOTEL, filename, category, progress) {
        return httpClient.delete(
            `${SOURCEURL}/shs-bedesigner-services/files?${FileService.fileParamProxy(
                chainId,
                hotelId,
                null,
                saveLevel,
                filename,
                category
            )}`,
            progress
        );
    }
}



// WEBPACK FOOTER //
// ./src/services/fileUpload/uploadFile.js